import React from 'react'

export default function ManagerChangePassword() {
  return (
    <div>
    
    </div>
  )
}
